import { useCallback, useEffect, useRef, useState } from "react";

const useController = () => {
	const wrapperRef = useRef(null);

	const [isVisible, setIsVisible] = useState(false);

	const toggleVisibility = useCallback(() => {
		if (wrapperRef.current && wrapperRef.current.scrollTop > 55) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	}, []);

	const handleClick = useCallback(() => {
		if (wrapperRef.current) {
			wrapperRef.current.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		}
	}, []);

	useEffect(() => {
		if (!wrapperRef.current) {
			wrapperRef.current = document.getElementById("WrapperMain");
		}

		if (wrapperRef.current) {
			wrapperRef.current.addEventListener("scroll", toggleVisibility);
		}
		return () => {
			if (wrapperRef.current) {
				wrapperRef.current.removeEventListener("scroll", toggleVisibility);
			}
		};
	}, [toggleVisibility]);

	return {
		state: { isVisible },
		handlers: { handleClick },
	};
};

export default useController;
